import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.svg'; // Adjust the path to your logo file
import './Logo.css';

const Logo = () => {
  return (
    <Link to="/business" className="logo-link" aria-label="Go to splash page">
      <div className="logo-container">
        <img src={logo} className="App-logo" alt="logo" />
        <span className="logo-text">Caltronic.Pro</span>
      </div>
    </Link>
  );
};

export default Logo;
